import { useMemo } from "react";

function parseIso(s) {
  if (!s) return null;
  try { return new Date(s); } catch { return null; }
}

export default function SyncIndicator({ lastSyncAtUtc }) {
  const { color, label } = useMemo(() => {
    const d = parseIso(lastSyncAtUtc);
    if (!d) return { color: "#dc2626", label: "Never synced" };
    const minutes = (Date.now() - d.getTime()) / 60000;
    // CampMinder syncs nightly — anything in the last 36 h is healthy.
    if (minutes < 60) return { color: "#16A34A", label: `Synced ${Math.max(1, Math.round(minutes))}m ago` };
    const hours = minutes / 60;
    if (hours < 36) return { color: "#16A34A", label: `Synced ${Math.round(hours)}h ago` };
    if (hours < 72) return { color: "#F59E0B", label: `Synced ${Math.round(hours)}h ago` };
    return { color: "#dc2626", label: `Stale: ${Math.round(hours)}h ago` };
  }, [lastSyncAtUtc]);

  return (
    <div className="flex items-center gap-2" data-testid="sync-indicator">
      <span className="pulse-dot" style={{ backgroundColor: color }} />
      <span className="text-xs font-medium text-slate-600">{label}</span>
    </div>
  );
}
